import React, { ReactNode } from 'react';
import { FormSummaryInfo } from '../FormSummaryInfo';
import { determineRuleType } from 'modules/jsonRulesCriterias/businessCriteria';
import { FinanceProgramForm } from '../../../../../schema';
import { criteriaViewer } from '../../../../../lib';

interface Props {
  financeProgramFormValues: FinanceProgramForm['program'];
}

export const CriteriaSummaryPart = ({ financeProgramFormValues: program }: Props) => {
  const formData = program.first.criteria.conditions;

  const renderData = formData.reduce<Record<string, ReactNode>>((acc, item) => {
    acc[
      item.fact
        .replace(/_/g, ' ')
        .toLowerCase()
        .replace(/\b(\w)/g, char => char.toUpperCase())
    ] = criteriaViewer(determineRuleType(item.fact), item);

    return acc;
  }, {});

  return <FormSummaryInfo data={renderData} />;
};
